import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: '[appDnd]',
    standalone: true
  })
  export class DndDirective {
    @HostBinding('class.fileover') fileOver: boolean;
    @Output() fileDropped = new EventEmitter<any>();
    
    @Input() disabled = false;

    // Dragover listener
    @HostListener('dragover', ['$event']) onDragOver(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.disabled) return; // blocca hover se disabilitato
        this.fileOver = true;
    }

    // Dragleave listener
    @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.disabled) return;
        this.fileOver = false;
    }

    // Drop listener
    @HostListener('drop', ['$event']) public ondrop(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.disabled) return; // blocca drop se disabilitato

        this.fileOver = false;
        let files = evt.dataTransfer.files;
        if (files.length > 0) {
            let payload: {files:any, event: Event} = {files: files, event: evt}
            this.fileDropped.emit(payload);
        }
    }
  }
